import React, { useEffect } from "react";
// import "./Login.css";
import { UCL_AUTH_URL } from "../../constants";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
// import googleLogo from "../../img/google-logo.png";


const SampleLogin = () => (
    <div className="social-login">
        <a className="btn btn-block social-btn google" href={UCL_AUTH_URL}>
            {/* <img src={googleLogo} alt="Google" />  */}
            <img src="https://s3.eu-west-2.amazonaws.com/uclapi-static/SignInWithUCLSmall.png"></img>
        </a>
    </div>
);


const Login = ({ authenticated }) => {
    
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // If the OAuth2 login encounters an error, the user is redirected to the /login page with an error.
        // Here we display the error and then remove the error query parameter from the location.
        if (location.state && location.state.error) {
            setTimeout(() => {
                navigate(location.pathname, {state: {}})
            }, 100);
        }
    });

    if (authenticated) {
        return (
            <Navigate
                replace to={{
                    pathname: "/",
                    state: { from: location }
                }}
            />
        );
    } else {
        return (
            <div className="login-container">
                <div className="login-content">
                    <h1 className="login-title">Login</h1>
                    <SampleLogin />
                </div>
            </div>
        );
    }
}

export default Login;